<script>
  export default {
    name: 'BaseCheckboxGroup',

    model: {
      prop: 'checked',
      event: 'change'
    },

    props: {
      checked: {
        type: Array,
        default: () => []
      },
      name: {
        type: String,
        required: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      stacked: {
        type: Boolean,
        default: false
      },
      switch: {
        type: Boolean,
        default: false
      }
    },

    render (createElement) {
      const defaultProps = {
        name: this.name,
        disabled: this.disabled,
        stacked: this.stacked,
        switch: this.switch
      }

      return createElement('div', { class: this.className, attrs: this.$attrs }, [
        this.$scopedSlots.default().map((slot, index) => {
          const { checked: value, ...props } = slot.componentOptions.propsData

          return this.$cloneNode(slot, {
            props: Object.assign({}, defaultProps, props, { checked: this.checked.includes(value) }),
            on: {
              change: (isChecked) => this.$emit('change', isChecked ? [...this.checked, value] : this.checked.filter(item => item !== value))
            }
          })
        })
      ])
    }
  }
</script>
